export const getNgoContributionForPanier = (
  doesClientContributeToNgo: boolean
): number => {
  if (doesClientContributeToNgo) return 1;
  if (!doesClientContributeToNgo) return 0;
};
